module.exports = __webpack_public_path__ + "static/media/team-mary.34da9bec.jpg";